import * as React from "react"

import { cn } from "@/lib/utils"

const MessageContext = React.createContext({ align: "start" })

const Message = React.forwardRef(({ align = "start", className, ...props }, ref) => (
  <MessageContext.Provider value={{ align }}>
    <div
      ref={ref}
      data-align={align}
      className={cn(
        "group/message flex w-full min-w-0 max-w-full items-end gap-2",
        align === "end" ? "flex-row-reverse justify-start" : "justify-start",
        className
      )}
      {...props}
    />
  </MessageContext.Provider>
))
Message.displayName = "Message"

const MessageAvatar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("shrink-0 self-end", className)}
    {...props}
  />
))
MessageAvatar.displayName = "MessageAvatar"

const MessageContent = React.forwardRef(({ className, ...props }, ref) => {
  const { align } = React.useContext(MessageContext)

  return (
    <div
      ref={ref}
      className={cn(
        "flex min-w-0 max-w-[min(78%,420px)] flex-col [overflow-wrap:anywhere]",
        align === "end" ? "items-end" : "items-start",
        className
      )}
      {...props}
    />
  )
})
MessageContent.displayName = "MessageContent"

const MessageFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("mt-1 px-1 text-[10px] font-semibold text-muted-foreground", className)}
    {...props}
  />
))
MessageFooter.displayName = "MessageFooter"

export { Message, MessageAvatar, MessageContent, MessageFooter }
